<div>
    <mat-toolbar style="background-color: white;">
        <mat-toolbar-row>
            <mat-form-field appearance="legacy" class="form-field-small">
                <mat-label>Filtre</mat-label>
                <mat-select>
                    <mat-option value="all">Tous</mat-option>
                    <mat-option value="option2">Actifs</mat-option>
                    <mat-option value="option3">Passifs</mat-option>
                </mat-select>
            </mat-form-field>
            <span>&nbsp;&nbsp;</span>
            <mat-form-field appearance="legacy" class="form-field-small">
                <mat-label>Tri</mat-label>
                <mat-select>
                    <mat-option value="none">Pas de tri</mat-option>
                    <mat-option value="option2">Avec risque</mat-option>
                    <mat-option value="option3">Sans risque</mat-option>
                </mat-select>
            </mat-form-field>
            <span class="toolbar-spacer"></span>
            <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" [length]="subject?.length" (page)="changePage($event)"></mat-paginator>
        </mat-toolbar-row>
    </mat-toolbar>    
    <table mat-table matSort [dataSource]="medications" class="medication-table">
        <ng-container matColumnDef="medication">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let medication">
                <app-medication-row [record]="medication" [mode]="'full'" (updated)="updated($event)"></app-medication-row>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
